import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export const SortableWidget = ({ id, isActive, children }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging, isOver } = useSortable({ id });

    const cardStyle = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <div
            ref={setNodeRef}
            className={`dashboard-widget-grid-item ${isDragging ? 'is-dragging' : ''} ${isActive ? 'is-active' : ''} ${
                isOver && !isDragging ? 'is-over' : ''
            }`}
            {...attributes}
            {...listeners}
        >
            <div className="dashboard-widget-grid-item__card" style={cardStyle}>
                {children}
            </div>
        </div>
    );
};
